module.exports = {
          srcSet: __webpack_public_path__ + "images/1925-28cd4806dc495c6ad8b8385336fe78f5-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1925-e3cf064457c32544596757df7f8f0d6b-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1925-28cd4806dc495c6ad8b8385336fe78f5-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1925-e3cf064457c32544596757df7f8f0d6b-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1925-28cd4806dc495c6ad8b8385336fe78f5-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1925-28cd4806dc495c6ad8b8385336fe78f5-320.jpg"},
          
          width: 320,
          height: 251
        }